import React, { useEffect, useReducer } from 'react';
import { connect } from 'dva';
import { createStructuredSelector } from 'reselect';

import './styles.pcss';
import AddressInput from '../AddressInput/AddressInput';
import AddressSubsequentRequestError from '../AddressMessages/AddressSubsequentRequestError';
import AddressSearch from '../AddressSearch/AddressSearch';
import AddressManualInputSwitch from '../AddressManualInputSwitch/AddressManualInputSwitch';
import AddressSpinner from '../AddressSpinner/AddressSpinner';
import AddressFlat from '../AddressFlat/AddressFlat';
import AddressFullViewSwitch from '../AddressFullViewSwitch/AddressFullViewSwitch';
import AddressOMKError from '../AddressMessages/AddressOMKError';
import {
  getAddressSearchValue,
  isAddressInManualMode,
  PersonModel,
} from '../../../../selectors/addressUnmodeled';
import { AddressFields } from '../../../../../types/address';
import AddressContinueButton from '../AddressContinueButton';
import { getAddressPlaceholder } from '../../../../helpers/getPlacelholder';
import AddressMissingDataInformer from '../AddressMessages/AddressMissingDataInformer';

interface Props {
  model: PersonModel;
  address: AddressFields['address']['value'];
  isManualInput: boolean;
}

function AddressDirectory({ address, model, isManualInput }: Props) {
  const [expanded, toggleExpanded] = useReducer(
    (state, action) => !state,
    false
  );

  // Сбрасываем состояние из развёрнутого в свёрнутое, если меняется адрес
  useEffect(() => {
    // Диспетчер должен содержать в себе какое-то значение, но нам пофиг
    if (expanded) toggleExpanded({});
  }, [address]);

  return (
    <div className="StepContentBlock">
      <AddressSearch
        model={model}
        placeholder={getAddressPlaceholder('search')}
      />
      {!isManualInput && <AddressSubsequentRequestError model={model} />}
      <AddressManualInputSwitch model={model} />
      <AddressInput model={model} isExpandedView={expanded} />
      {!isManualInput && (
        <AddressFlat isExpandedView={expanded} model={model} />
      )}
      <AddressFullViewSwitch
        model={model}
        isExpandedView={expanded}
        onClick={toggleExpanded}
      />
      <AddressSpinner model={model} />
      <AddressOMKError model={model} />
      <AddressMissingDataInformer model={model} />
      <AddressContinueButton model={model} />
    </div>
  );
}

const mapStateToProps = createStructuredSelector({
  address: getAddressSearchValue,
  isManualInput: isAddressInManualMode,
});

export default connect(mapStateToProps)(AddressDirectory);
